import * as React from 'react';
import ServiceList from "./ServiceList";
import {Subbar, Title, PageHeader} from "ah-tools";

class ServiceCompleteList extends React.Component {
	
	render = () => {
	
		return (
			<React.Fragment>
				<PageHeader align={Subbar.ALIGN_BETWEEN}>
					<Subbar>
						<Title>Alle Dienste (Liste)</Title>
					</Subbar>
				</PageHeader>
				<ServiceList services={[]} />
			</React.Fragment>
		);
	};
}

export default ServiceCompleteList;


// WEBPACK FOOTER //
// ./src/components/ServiceCompleteList.js